import { render, staticRenderFns } from "./Item_Code.vue?vue&type=template&id=54d3accc&scoped=true"
import script from "./Item_Code.vue?vue&type=script&lang=js"
export * from "./Item_Code.vue?vue&type=script&lang=js"
import style0 from "./Item_Code.vue?vue&type=style&index=0&id=54d3accc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3accc",
  null
  
)

export default component.exports